export const isElementVisible = (element: HTMLElement | null): boolean => {
  if (!element) {
    return false;
  }

  const containerBottom = element.getBoundingClientRect().bottom;
  const windowInnerHeight = document.documentElement.clientHeight;

  return containerBottom < windowInnerHeight;
};
